import { Component, defineComponent } from '@decify/cell-shopify/client';
import './Form.scss';
export const formName = 'Form';
export const formTagName = 'cell-component-form';
export const formChangeEvent = 'change';
export const formSubmitEvent = 'submit';
export class Form extends Component {
    constructor() {
        super(formName);
        this.validateProps(['preventDefault']);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        this.formElement.subscribe('change', this.handleChange);
        this.formElement.subscribe('submit', this.handleSubmit);
    }
    handleChange() {
        this.publish(formChangeEvent, this.formDataObj);
    }
    handleSubmit(_, event) {
        if (this.props.preventDefault) {
            event.preventDefault();
        }
        this.publish(formSubmitEvent, this.formDataObj);
    }
    get formElement() {
        const formElement = this.querySelector('form');
        if (!formElement) {
            throw new Error('Form element not found');
        }
        return formElement;
    }
    get formDataObj() {
        const formData = new FormData(this.formElement);
        const formDataObj = {};
        for (const [key, value] of formData.entries()) {
            const valueStr = value.toString();
            const existingEntry = formDataObj[key];
            if (existingEntry) {
                if (Array.isArray(existingEntry)) {
                    existingEntry.push(valueStr);
                }
                else {
                    formDataObj[key] = [existingEntry, valueStr];
                }
            }
            else {
                formDataObj[key] = valueStr;
            }
        }
        return formDataObj;
    }
}
defineComponent(formTagName, Form);
